<template>
  <div
    class="goal-content page-card-wrapper"
    :class="this.$store.state.locale.currentLocale === 'de' ? 'de-wrapper' : ''"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.skin_care_goal_title')
      }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-30 page-content">
        <div class="light-blue-font mb-30">
          {{ $t('text.day_goal').toUpperCase() }}
        </div>
        <div class="slider-wrapper h-100">
          <span
            v-if="dayValue"
            class="value-text light-blue-font"
            :style="{ left: dayValue / (this.max / 100) + '%' }"
            >{{ valueText(dayValue) }}</span
          >
          <el-slider
            v-model="dayValue"
            :min="0"
            :max="max"
            :step="0.5"
            :show-tooltip="false"
          >
          </el-slider>
          <div class="min-value light-blue-font">{{ $t('text.off') }}</div>
          <div class="max-value light-blue-font">{{ max }}h</div>
        </div>
        <div class="light-blue-font mb-30 mt-20">
          {{ $t('text.night_goal').toUpperCase() }}
        </div>
        <div class="slider-wrapper h-100">
          <span
            v-if="nightValue"
            class="value-text light-blue-font"
            :style="{ left: nightValue / (this.max / 100) + '%' }"
            >{{ valueText(nightValue) }}</span
          >
          <el-slider
            v-model="nightValue"
            :min="0"
            :max="max"
            :step="0.5"
            :show-tooltip="false"
          >
          </el-slider>
          <div class="min-value light-blue-font">{{ $t('text.off') }}</div>
          <div class="max-value light-blue-font">{{ max }}h</div>
        </div>
        <div class="text-right mt-10">
          <b-button variant="outline-primary" class="mr-25 visibile-hide">{{
            $t('text.default').toUpperCase()
          }}</b-button>
          <el-button
            type="success"
            plain
            class="common-btn"
            :loading="saveLoading"
            @click="save()"
            :disabled="saveLoading"
            v-if="p('Patients.Goals Module.Skin Care.Save')"
            >{{ $t('text.save').toUpperCase() }}</el-button
          >
        </div>
        <div class="setting-wrapper mt-40 mb-30">
          <div class="image-wrapper inline-block">
            <img src="@/assets/image/light.svg" />
          </div>
          <div class="inline-block">
            <div class="first-row">
              <span class="left-side">
                <span class="inline-block label"
                  >{{
                    $t('text.average_time_in_pad') | firstLetterCapitalize
                  }}:</span
                >
                <span class="value">
                  <span v-if="patientData.AvgTimeinPad">
                    <span v-if="secondFormat(patientData.AvgTimeinPad)[0]"
                      >{{ secondFormat(patientData.AvgTimeinPad)[0] }}d
                    </span>
                    <span v-if="secondFormat(patientData.AvgTimeinPad)[1]">
                      {{ secondFormat(patientData.AvgTimeinPad)[1] }}h
                    </span>
                    <span v-if="secondFormat(patientData.AvgTimeinPad)[2]">
                      {{ secondFormat(patientData.AvgTimeinPad)[2] }}min
                    </span>
                  </span>
                  <span v-else>0min</span></span
                >
              </span>
              <span class="right-side">
                <span class="label inline-block"
                  >{{ $t('text.repositioning_24h') }}:</span
                >
                <span
                  >{{ patientData.Reposition }} {{ $t('text.per_day') }} ({{
                    $t('text.avg')
                  }})</span
                >
              </span>
            </div>
            <div class="second-row">
              <span class="left-side">
                <span class="inline-block label"
                  >{{
                    $t('text.average_time_in_position') | firstLetterCapitalize
                  }}:</span
                >
                <span class="value">
                  <span v-if="patientData.AgvTimeinPos">
                    <span v-if="secondFormat(patientData.AgvTimeinPos)[0]"
                      >{{ secondFormat(patientData.AgvTimeinPos)[0] }}d
                    </span>
                    <span v-if="secondFormat(patientData.AgvTimeinPos)[1]">
                      {{ secondFormat(patientData.AgvTimeinPos)[1] }}h
                    </span>
                    <span v-if="secondFormat(patientData.AgvTimeinPos)[2]"
                      >{{ secondFormat(patientData.AgvTimeinPos)[2] }}min</span
                    >
                  </span>
                  <span v-else>0min</span></span
                >
              </span>
              <span class="right-side"
                >{{ $t('text.last_7_day_period') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dayValue: 0,
      nightValue: 0,
      max: 16,
      patientData: {},
      saveLoading: false
    }
  },
  computed: {
    secondFormat() {
      return function(num) {
        if (!num) return [0, 0, 0]
        let day = Math.floor(num / 86400)
        let hour = Math.floor((num - day * 86400) / 3600)
        let mimute = Math.floor((num - day * 86400 - hour * 3600) / 60)
        return [day, hour, mimute]
      }
    },
    valueText() {
      return value => {
        let num1 = Math.floor(value)
        let num2 = (value - num1) * 60
        if (num2) {
          if (num1) {
            return num1 + 'h' + ' ' + num2 + 'm'
          } else {
            return num2 + 'min'
          }
        }
        return num1 + 'h'
      }
    }
  },
  watch: {
    '$store.state.patient.selectedPatientGoal': function() {
      this.getInitVal()
    },
    '$store.state.patient.selectedPatientData': function() {
      this.getPatientData()
    }
  },
  mounted() {
    this.$store.dispatch('patient/getSelectedPatientGoal')
    this.$store.dispatch('patient/getSelectedPatientHistoryData')
    this.getInitVal()
    this.getPatientData()
  },
  methods: {
    getInitVal() {
      let goal = this.$store.state.patient.selectedPatientGoal
      this.dayValue = goal.MaxTimeInPadD / 3600
      this.nightValue = goal.MaxTimeInPadN / 3600
    },
    getPatientData() {
      this.patientData = this.$store.state.patient.selectedPatientData
    },
    save() {
      if (!this.$store.state.patient.selectedPatient) return false
      let params = {
        patientId: this.$store.state.patient.selectedPatient.patientId,
        MaxTimeInPadD: this.dayValue * 3600,
        MaxTimeInPadN: this.nightValue * 3600
      }
      this.saveLoading = true
      ApiService.SaveSkinCareGoal(params)
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            this.$store.dispatch('patient/getSelectedPatientGoal')
            this.$store.dispatch('patient/getSelectedPatientHistoryData')
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.saved_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.saved_failed')
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.de-wrapper {
  .left-side {
    margin-right: 20px !important;
    .label {
      width: 250px;
    }
  }
  .right-side {
    .label {
      width: 130px;
    }
  }
}
</style>
